import { useCacheStorage } from '@/shared/lib/hooks/use-cache-storage';
import { CIType } from '@/entities/srm/ci';
import { Tree } from '@/shared/lib/utils/tree/types';
import { ciTypesTreeQueryConfig } from './ci-type-query-config';

export const useCITypeTreeStorage = () => {
  return useCacheStorage<Tree<CIType>>({
    queryConfig: ciTypesTreeQueryConfig,
  });
};